import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError, of } from 'rxjs';
import { articleCountResults } from 'constants/routes'


/**
 * Fetches the article count results based on the provided payload.
 *
 * @param {Object} payload - The payload containing the search command for blog articles.
 * @returns {Observable<number|string>} An observable that emits the response text from the API
 * or `0` in case of an error.
 */
const getArticleCountResults$ = (payload) => {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      BlogArticlesSearchCommand: payload
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };

  return fromFetch(articleCountResults, requestObject).pipe(
    switchMap((response) => response.text()),
    catchError(() => of(0))
  );
}

export default getArticleCountResults$;